export default __webpack_public_path__ + "static/media/contactside.3d2069d5.jpg";